<template>
  <AppNavbar></AppNavbar>
  <div class="view">
    <router-view></router-view>
  </div>
  <AppFooter></AppFooter>
</template>

<script>
import AppNavbar from "@/layout/Navbar.vue";
import AppFooter from "@/layout/Footer.vue";

export default {
  components: {
    AppNavbar,
    AppFooter,
  },
  setup() {},
};
</script>
